const FairplayLogo = 'theme/Fairplaylive/title.png';
const FairplayIcon = 'theme/Fairplaylive/favicon.png';
const Gin247Logo = 'theme/Gin247co/title.png';
const Gin247Icon = 'theme/Gin247co/favicon.png';
const Guru365Logo = 'theme/Guru365com/title.png';
const Guru365Icon = 'theme/Guru365com/favicon.png';
const Mahakal365Logo = 'theme/Mahakal365com/title.png';
const Mahakal365Icon = 'theme/Mahakal365com/favicon.png';
const MurganbookLogo = 'theme/Murganbookcom/title.png';
const MurganbookIcon = 'theme/Murganbookcom/favicon.png';
const PlayaddaLogo = 'theme/Playaddacom/title.png';
const PlayaddaIcon = 'theme/Playaddacom/favicon.png';
const Reddy888Logo = 'theme/Reddy888com/title.png';
const Reddy888Icon = 'theme/Reddy888com/favicon.png';
const SouthbookLogo = 'theme/Southbookin/title.png';
const Stake247Logo = 'theme/Stake247com/title.png';
const Stake786Logo = 'theme/Stake786com/title.png';
const SouthbookIcon = 'theme/Southbookin/favicon.png';
const Stake247Icon = 'theme/Stake247com/favicon.png';
const Stake786Icon = 'theme/Stake786com/favicon.png';
const TheDafabetLogo = 'theme/Thedafabetwin/title.png';
const TheDafabetIcon = 'theme/Thedafabetwin/favicon.png';
const UltrawinCoLogo = 'theme/Ultrawin/title.png';
const UltrawinCoIcon = 'theme/Ultrawin/favicon.png';
const UltrawinClubLogo = 'theme/Ultrawinclub/title.png';
const UltrawinClubIcon = 'theme/Ultrawinclub/favicon.png';
const VardaanLogo = 'theme/Vardaanvip/title.png';
const VardaanIcon = 'theme/Vardaanvip/favicon.png';
const WinaddaLogo = 'theme/Winaddain/title.png';
const WinaddaIcon = 'theme/Winaddain/favicon.png';
const EmpirexchLogo = 'theme/Empirexchcom/title.png';
const EmpirexchIcon = 'theme/Empirexchcom/favicon.png';
const CricplayLogo = 'theme/Cricplaygames/title.png';
const CricplayIcon = 'theme/Cricplaygames/favicon.png';
const LuxuryplayLogo = 'theme/Luxuryplayin/title.png';
const LuxuryplayIcon = 'theme/Luxuryplayin/favicon.png';
const Games365Icon = 'theme/Games365vip/favicon.png';
const Games365Logo = 'theme/Games365vip/title.png';
const IndoplayLogo = 'theme/Indoplayvip/title.png';
const IndoplayIcon = 'theme/Indoplayvip/favicon.png';
const MarioplayIcon = 'theme/Marioplaylive/favicon.png';
const MarioplayLogo = 'theme/Marioplaylive/title.png';
const Betin365Icon = 'theme/Betin365win/favicon.svg';
const Betin365Logo = 'theme/Betin365win/title.svg';
const Six666Icon = 'theme/Six666com/favicon.png';
const Six666Logo = 'theme/Six666com/title.png';
const LakshmiWinLogo = 'theme/Lakshmiwincom/title.png';
const LakshmiWinIcon = 'theme/Lakshmiwincom/favicon.png';
const Madhav247liveLogo = 'theme/Madhav247live/title.png';
const Madhav247liveIcon = 'theme/Madhav247live/favicon.svg';
const Run247winLogo = 'theme/Run247win/title.png';
const Run247winIcon = 'theme/Run247win/favicon.png';
const Vistara365comLogo = 'theme/Vistara365com/title.png';
const Vistara365comIcon = 'theme/Vistara365com/favicon.png';
const Jackpot247liveLogo = 'theme/Jackpot247live/title.png';
const Jackpot247liveIcon = 'theme/Jackpot247live/favicon.png';

const faiplayLiveEnvs = {
  FOLDER_NAME: 'Fairplaylive',
  BRAND_NAME: 'Fairplay',
  BRAND_DOMAIN: 'fairplay.live',
  logo: FairplayLogo,
  favicon: FairplayIcon,
};
const gin247Envs = {
  FOLDER_NAME: 'Gin247co',
  BRAND_NAME: 'Gin247',
  BRAND_DOMAIN: 'gin247.co',
  logo: Gin247Logo,
  favicon: Gin247Icon,
};
const guru365Envs = {
  FOLDER_NAME: 'Guru365com',
  BRAND_NAME: 'Guru365',
  BRAND_DOMAIN: 'guru365.com',
  logo: Guru365Logo,
  favicon: Guru365Icon,
};
const mahakal365Envs = {
  FOLDER_NAME: 'Mahakal365com',
  BRAND_NAME: 'Mahakal365',
  BRAND_DOMAIN: 'mahakal365.com',
  logo: Mahakal365Logo,
  favicon: Mahakal365Icon,
};
const murganBookEnvs = {
  FOLDER_NAME: 'Murganbookcom',
  BRAND_NAME: 'MurganBook',
  BRAND_DOMAIN: 'murganbook.com',
  logo: MurganbookLogo,
  favicon: MurganbookIcon,
};
const playAddaEnvs = {
  FOLDER_NAME: 'Playaddacom',
  BRAND_NAME: 'Playadda',
  BRAND_DOMAIN: 'playadda.com',
  logo: PlayaddaLogo,
  favicon: PlayaddaIcon,
};
const reddy888Envs = {
  FOLDER_NAME: 'Reddy888com',
  BRAND_NAME: 'Reddy888',
  BRAND_DOMAIN: 'reddy888.com',
  logo: Reddy888Logo,
  favicon: Reddy888Icon,
};
const southbookInEnvs = {
  FOLDER_NAME: 'Southbookin',
  BRAND_NAME: 'Southbook',
  BRAND_DOMAIN: 'southbook.in',
  logo: SouthbookLogo,
  favicon: SouthbookIcon,
};
const stake247Envs = {
  FOLDER_NAME: 'Stake247com',
  BRAND_NAME: 'Stake247',
  BRAND_DOMAIN: 'stake247.com',
  logo: Stake247Logo,
  favicon: Stake247Icon,
};
const stake786Envs = {
  FOLDER_NAME: 'Stake786com',
  BRAND_NAME: 'Stake786',
  BRAND_DOMAIN: 'stake786.com',
  logo: Stake786Logo,
  favicon: Stake786Icon,
};
const theDafabetEnvs = {
  FOLDER_NAME: 'Thedafabetwin',
  BRAND_NAME: 'The Dafabet',
  BRAND_DOMAIN: 'thedafabet.win',
  logo: TheDafabetLogo,
  favicon: TheDafabetIcon,
};
const ultrawinCoEnvs = {
  FOLDER_NAME: 'Ultrawin',
  BRAND_NAME: 'Ultrawin',
  BRAND_DOMAIN: 'ultrawin.games',
  logo: UltrawinCoLogo,
  favicon: UltrawinCoIcon,
};
const ultrawinClubEnvs = {
  FOLDER_NAME: 'Ultrawinclub',
  BRAND_NAME: 'Ultrawin',
  BRAND_DOMAIN: 'ultrawin.club',
  logo: UltrawinClubLogo,
  favicon: UltrawinClubIcon,
};
const vardaanVipEnvs = {
  FOLDER_NAME: 'Vardaanvip',
  BRAND_NAME: 'Vardaan',
  BRAND_DOMAIN: 'vardaan.vip',
  logo: VardaanLogo,
  favicon: VardaanIcon,
};
const winaddaInEnvs = {
  FOLDER_NAME: 'Winaddain',
  BRAND_NAME: 'Winadda',
  BRAND_DOMAIN: 'winadda.in',
  logo: WinaddaLogo,
  favicon: WinaddaIcon,
};
const empirexchEnvs = {
  FOLDER_NAME: 'Empirexchcom',
  BRAND_NAME: 'Empirexch',
  BRAND_DOMAIN: 'empirexch.com',
  logo: EmpirexchLogo,
  favicon: EmpirexchIcon,
};
const cricplayEnvs = {
  FOLDER_NAME: 'Cricplaygames',
  BRAND_NAME: 'Cricplay',
  BRAND_DOMAIN: 'cricplay.games',
  logo: CricplayLogo,
  favicon: CricplayIcon,
};
const luxuryplayEnvs = {
  FOLDER_NAME: 'Luxuryplayin',
  BRAND_NAME: 'Luxuryplay',
  BRAND_DOMAIN: 'luxuryplay.in',
  logo: LuxuryplayLogo,
  favicon: LuxuryplayIcon,
};
const Games365VipEnvs = {
  FOLDER_NAME: 'Games365vip',
  BRAND_NAME: 'Games365',
  BRAND_DOMAIN: 'games365.vip',
  logo: Games365Logo,
  favicon: Games365Icon,
};

const IndoplayVipEnvs = {
  FOLDER_NAME: 'Indoplayvip',
  BRAND_NAME: 'Indoplay',
  BRAND_DOMAIN: 'indoplay.vip',
  logo: IndoplayLogo,
  favicon: IndoplayIcon,
};

const MarioplayliveEnvs = {
  FOLDER_NAME: 'Marioplaylive',
  BRAND_NAME: 'Marioplay',
  BRAND_DOMAIN: 'marioplay.live',
  logo: MarioplayLogo,
  favicon: MarioplayIcon,
};

const Betin365winEnvs = {
  FOLDER_NAME: 'Betin365win',
  BRAND_NAME: 'Betin365',
  BRAND_DOMAIN: 'betin365.win',
  logo: Betin365Logo,
  favicon: Betin365Icon,
};

const Six666comEnvs = {
  FOLDER_NAME: 'Six666com',
  BRAND_NAME: 'Six666',
  BRAND_DOMAIN: 'six666.com',
  logo: Six666Logo,
  favicon: Six666Icon,
};

const LakshmiwincomEnvs = {
  FOLDER_NAME: 'Lakshmiwincom',
  BRAND_NAME: 'LakshmiWin',
  BRAND_DOMAIN: 'lakshmiwin.com',
  logo: LakshmiWinLogo,
  favicon: LakshmiWinIcon,
};

const Madhav247liveEnvs = {
  FOLDER_NAME: 'Madhav247live',
  BRAND_NAME: 'Madhav247',
  BRAND_DOMAIN: 'madhav247.live',
  logo: Madhav247liveLogo,
  favicon: Madhav247liveIcon,
};

const Run247winEnvs = {
  FOLDER_NAME: 'Run247win',
  BRAND_NAME: 'Run247',
  BRAND_DOMAIN: 'run247.win',
  logo: Run247winLogo,
  favicon: Run247winIcon,
};

const Vistara365Envs = {
  FOLDER_NAME: 'Vistara365com',
  BRAND_NAME: 'Vistara365',
  BRAND_DOMAIN: 'vistara365.com',
  logo: Vistara365comLogo,
  favicon: Vistara365comIcon,
};

const Jackpot247Envs = {
  FOLDER_NAME: 'Jackpot247live',
  BRAND_NAME: 'Jackpot247',
  BRAND_DOMAIN: 'jackpot247.live',
  logo: Jackpot247liveLogo,
  favicon: Jackpot247liveIcon,
};

export const WhitelabelEnvMap = {
  localhost: ultrawinCoEnvs,

  // Stage domains
  'stage.ultrawin.games': ultrawinCoEnvs,
  'stage.playadda.com': playAddaEnvs,
  'stage.fairplay.live': faiplayLiveEnvs,
  'stage.guru365.com': guru365Envs,
  'stage.vardaan.vip': vardaanVipEnvs,

  // Prod domains
  'fairplay.live': faiplayLiveEnvs,
  'gin247.co': gin247Envs,
  'guru365.com': guru365Envs,
  'mahakal365.com': mahakal365Envs,
  'murganbook.com': murganBookEnvs,
  'playadda.com': playAddaEnvs,
  'reddy888.com': reddy888Envs,
  'southbook.in': southbookInEnvs,
  'stake247.com': stake247Envs,
  'stake786.com': stake786Envs,
  'thedafabet.win': theDafabetEnvs,
  'ultrawin.co': ultrawinCoEnvs,
  'ultrawin.club': ultrawinClubEnvs,
  'vardaan.vip': vardaanVipEnvs,
  'winadda.in': winaddaInEnvs,
  'empirexch.com': empirexchEnvs,
  'cricplay.games': cricplayEnvs,
  'games365.vip': Games365VipEnvs,
  'indoplay.vip': IndoplayVipEnvs,
  'marioplay.live': MarioplayliveEnvs,
  'six666.com': Six666comEnvs,
  'lakshmiwin.com': LakshmiwincomEnvs,
  'madhav247.live': Madhav247liveEnvs,
  'run247.win': Run247winEnvs,
  'vistara365.com': Vistara365Envs,

  // Aliases
  'ultrawin.games': ultrawinCoEnvs,
  'ultrawin.app': ultrawinCoEnvs,
  'ultrawin.bet': ultrawinCoEnvs,
  'ultrawin.casino': ultrawinCoEnvs,
  'ultrawinclub.com': ultrawinCoEnvs,
  'ultrawin.co.in': ultrawinCoEnvs,
  'ultrawin.me': ultrawinCoEnvs,

  'fairplay365.games': faiplayLiveEnvs,
  'fairplaysite.co.in': faiplayLiveEnvs,
  'fairplaysite.com': faiplayLiveEnvs,
  'fairplaygames.online': faiplayLiveEnvs,
  'fairplay.blue': faiplayLiveEnvs,
  'fairplay.global': faiplayLiveEnvs,
  'fairplaysite.app': faiplayLiveEnvs,

  'gin247.games': gin247Envs,
  'gin247.info': gin247Envs,
  'gin247.org': gin247Envs,
  'gin247.tech': gin247Envs,

  'mahakal365.club': mahakal365Envs,
  'mahakal365.online': mahakal365Envs,
  'mahakal365.pro': mahakal365Envs,
  'mahakal365.io': mahakal365Envs,
  'mahakal365.app': mahakal365Envs,

  'murganbook.co.in': murganBookEnvs,
  'murganbook.live': murganBookEnvs,
  'murganbook.online': murganBookEnvs,
  'murganbook.site': murganBookEnvs,
  'murganbook.app': murganBookEnvs,

  'playadda.co.in': playAddaEnvs,
  'playadda.io': playAddaEnvs,
  'playadda.pro': playAddaEnvs,
  'playadda.vip': playAddaEnvs,
  'playadda.app': playAddaEnvs,

  'stake786.pro': stake786Envs,
  'stake786.online': stake786Envs,
  'stake786.site': stake786Envs,
  'stake786.club': stake786Envs,
  'stake786.app': stake786Envs,

  'vardaan.site': vardaanVipEnvs,
  'vardaan.cloud': vardaanVipEnvs,
  'vardaan.online': vardaanVipEnvs,
  'vardaan.io': vardaanVipEnvs,
  'vardaan.xyz': vardaanVipEnvs,

  'winadda.co.in': winaddaInEnvs,
  'winadda.online': winaddaInEnvs,
  'winadda.live': winaddaInEnvs,
  'winadda.site': winaddaInEnvs,
  'winadda.app': winaddaInEnvs,

  'guru365.io': guru365Envs,
  'guru365.site': guru365Envs,
  'guru365.online': guru365Envs,
  'guru365.games': guru365Envs,
  'guru365.app': guru365Envs,

  'luxuryplay.in': luxuryplayEnvs,
  'luxuryplay.co': luxuryplayEnvs,
  'luxuryplay.co.in': luxuryplayEnvs,
  'luxury-play.com': luxuryplayEnvs,
  'luxuryplay.app': luxuryplayEnvs,

  'games365.us': Games365VipEnvs,
  'games365.biz': Games365VipEnvs,
  'games365.pro': Games365VipEnvs,
  'games365.app': Games365VipEnvs,

  'indoplay.site': IndoplayVipEnvs,
  'indoplay.co.in': IndoplayVipEnvs,
  'indoplay.club': IndoplayVipEnvs,
  'indoplay.tech': IndoplayVipEnvs,

  'marioplay.co': MarioplayliveEnvs,
  'marioplay.club': MarioplayliveEnvs,
  'marioplay.co.in': MarioplayliveEnvs,
  'marioplay.app': MarioplayliveEnvs,

  'betin365.win': Betin365winEnvs,
  'betin365.club': Betin365winEnvs,
  'betin365.co.in': Betin365winEnvs,
  'betin365.online': Betin365winEnvs,
  'betin365.site': Betin365winEnvs,

  'six666.io': Six666comEnvs,
  'six666.online': Six666comEnvs,
  'six666.pro': Six666comEnvs,
  'six666.app': Six666comEnvs,

  'lakshmiwin.club': LakshmiwincomEnvs,
  'lakshmiwin.online': LakshmiwincomEnvs,
  'lakshmiwin.co': LakshmiwincomEnvs,
  'lakshmiwin.live': LakshmiwincomEnvs,
  'lakshmiwin.app': LakshmiwincomEnvs,

  'madhav247.in': Madhav247liveEnvs,
  'madhav247.online': Madhav247liveEnvs,
  'madhav247.vip': Madhav247liveEnvs,
  'madhav247.co.in': Madhav247liveEnvs,
  'madhav247.club': Madhav247liveEnvs,

  'run247.site': Run247winEnvs,
  'run247.co.in': Run247winEnvs,
  'run247.online': Run247winEnvs,
  'run247.app': Run247winEnvs,

  'vistara365.in': Vistara365Envs,
  'vistara365.online': Vistara365Envs,
  'vistara365.club': Vistara365Envs,
  'vistara365.live': Vistara365Envs,
  'vistara365.net': Vistara365Envs,

  'jackpot247.live': Jackpot247Envs,
  'jackpot247.vip': Jackpot247Envs,
  'jackpot247.site': Jackpot247Envs,
};

export function getEnvVariable(domain: string, variable: string) {
  return WhitelabelEnvMap[domain.replace(/www./g, '')][variable];
}
